import React from 'react';
import ReactDOM from 'react-dom';
import UserMenuApp from './UserMenuApp';

window.onload = ()=>{
  ReactDOM.render(<UserMenuApp />, document.getElementById('user_menu'));
}



// WEBPACK FOOTER //
// ./src/userMenuIndex.js